// eslint-disable-next-line import/prefer-default-export
export const setProperty = property => async dispatch => {
  dispatch({type: 'SET_PROPERTY', property});
  dispatch({
    type: 'USER_HAS_SELECTED_PROPERTY',
    hasSelectedProperty: property !== null,
  });
};
